// extracted by mini-css-extract-plugin
module.exports = {"OpenPanelIcons":"NavbarIcons_OpenPanelIcons__3KiIy","PanelOpen":"NavbarIcons_PanelOpen__2bHoC","ClosePanelIcon":"NavbarIcons_ClosePanelIcon__1iTpK"};